// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jOg4o","name":"styles_name__r7Ntb"};